/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SavingProductGroupPayoutsOutputDto { 
    id?: number;
    memberId?: number;
    savingProductId?: number;
    savingProductCycleId?: number;
    amount?: number;
    transactionId?: string;
    cycleNumber?: number;
    userId?: number;
    fullName?: string | null;
    emailAddress?: string | null;
    status?: string | null;
    paymentTransactionId?: string | null;
    savingProductName?: string | null;
}

